import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import EmailIcon from '@mui/icons-material/Email';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import moment from 'moment';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../Theme'; // Adjust the path to where your theme is located
import TopBar from './TopBar'; // Adjust the path to where your TopBar component is located
import Sidebar from './Sidebar'; // Adjust the path to where your Sidebar component is located
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Alert,
  Paper,
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tabs,
  Tab,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Switch,
  FormControlLabel,
  Snackbar,
  CssBaseline,
  Toolbar,
  TableBody,
  TablePagination
} from '@mui/material';
import './CSS/OrganizationDashboard.css';
import { API_URL } from '../apiConfig';


const roles = ['Admin', 'Member', 'Viewer'];

const OrganizationDashboard = ({ darkMode, setDarkMode, handleLogout }) => {
  const [profile, setProfile] = useState({});
  const [teamMembers, setTeamMembers] = useState([]);
  const [newMember, setNewMember] = useState({ name: '', email: '', role: roles[1], phone_number: '' });
  const [showAddMember, setShowAddMember] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editMember, setEditMember] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [confirmRoleChangeOpen, setConfirmRoleChangeOpen] = useState(false);
  const [confirmAdminRoleOpen, setConfirmAdminRoleOpen] = useState(false);
  const [updatedRole, setUpdatedRole] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const [activities, setActivities] = useState([]);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('timestamp');
  const [isCardView, setIsCardView] = useState(true);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [selectedMemberEmail, setSelectedMemberEmail] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [nameError, setNameError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [csrfToken, setCsrfToken] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [subscription, setSubscription] = useState({});
  const [availablePlans, setAvailablePlans] = useState([]);
  const [billingHistory, setBillingHistory] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [chosenPaymentMethod, setChosenPaymentMethod] = useState('');
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [methodToChange, setMethodToChange] = useState(null);
  const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);
  const [finalWarningOpen, setFinalWarningOpen] = useState(false);
  const [confirmReactivateOpen, setConfirmReactivateOpen] = useState(false);
  const [confirmUpgradeOpen, setConfirmUpgradeOpen] = useState(false);
  const [confirmDowngradeOpen, setConfirmDowngradeOpen] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(null);

  const [confirmDeleteAccountOpen, setConfirmDeleteAccountOpen] = useState(false);
  const [deletionStatus, setDeletionStatus] = useState('not_requested');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const toggleAddMemberForm = (e) => {
    e.stopPropagation();
    setShowAddMember(!showAddMember);
  };

  

  useEffect(() => {
    fetchDeletionStatus();
  }, []);

  const fetchDeletionStatus = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_URL}/api/account_deletion_status`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDeletionStatus(response.data.status);
    } catch (error) {
      console.error('Error fetching account deletion status:', error);
    }
  };

  const handleToggleAccountDeletion = () => {
    setConfirmDeleteAccountOpen(true);
  };

  const confirmToggleAccountDeletion = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.post(
        `${API_URL}/api/toggle_account_deletion`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-CSRFToken': csrfToken,
          },
          withCredentials: true,
        }
      );
      alert(response.data.message);
      setDeletionStatus(response.data.status);
    } catch (error) {
      console.error('Error toggling account deletion:', error);
      if (error.response && error.response.data) {
        alert(error.response.data.message || 'An error occurred while managing account deletion.');
      } else {
        alert('An error occurred while managing account deletion. Please try again later.');
      }
    } finally {
      setConfirmDeleteAccountOpen(false);
    }
  };

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/get-csrf-token`, { withCredentials: true });
        setCsrfToken(response.data.csrf_token);
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    const fetchData = async () => {
      const token = localStorage.getItem('accessToken');
      setLoading(true);
      try {
        const [profileRes, teamRes] = await Promise.all([
          axios.get(`${API_URL}/api/user_details`, {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          }),
          axios.get(`${API_URL}/api/team_members`, {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          })
        ]);

        setProfile(profileRes.data);
        setTeamMembers(teamRes.data);

        if (profileRes.data.role === 'Admin' || profileRes.data.type === 'user') {
          const [subscriptionRes, plansRes, billingHistoryRes, paymentMethodsRes, activitiesRes] = await Promise.all([
            axios.get(`${API_URL}/api/subscription`, {
              headers: { Authorization: `Bearer ${token}` },
              withCredentials: true
            }),
            axios.get(`${API_URL}/api/plans`, {
              headers: { Authorization: `Bearer ${token}` },
              withCredentials: true
            }),
            axios.get(`${API_URL}/api/billing_history`, {
              headers: { Authorization: `Bearer ${token}` },
              withCredentials: true
            }),
            axios.get(`${API_URL}/api/payment-methods`, {
              headers: { Authorization: `Bearer ${token}` },
              withCredentials: true
            }),
            axios.get(`${API_URL}/api/activities?limit=100`, {
              headers: { Authorization: `Bearer ${token}` },
              withCredentials: true
            })
          ]);

          setSubscription(subscriptionRes.data);
          setAvailablePlans(plansRes.data);
          setBillingHistory(billingHistoryRes.data);
          setPaymentMethods(paymentMethodsRes.data);
          setActivities(activitiesRes.data);

          // Fetch chosen payment method
          const chosenPaymentMethodRes = await axios.get(`${API_URL}/api/user/${profileRes.data.user_uuid}/payment-method`, {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          });

          if (chosenPaymentMethodRes.data.method_name) {
            setChosenPaymentMethod(chosenPaymentMethodRes.data.method_name);
          }
        }

        setLoading(false);
      } catch (error) {
        if (error.response && error.response.data.message === 'Email not verified. Please verify your email to access team members.') {
          setError('You need to verify your email to access this page. Go to the settings page to resolve this.');
        } else {
          setError('Failed to fetch data');
        }
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    };

    fetchCsrfToken();
    fetchData();
  }, []);

  const fetchSubscriptionData = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios.get(`${API_URL}/api/subscription`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true
      });
      setSubscription(response.data);
    } catch (error) {
      console.error('Error fetching subscription data:', error);
    }
  };

  const handleCancelSubscription = () => {
    setConfirmCancelOpen(true);
  };

  const handleFinalWarning = () => {
    setConfirmCancelOpen(false);
    setFinalWarningOpen(true);
  };

  const handleCancelSubscriptionClose = () => {
    setConfirmCancelOpen(false);
    setFinalWarningOpen(false);
  };

  const confirmCancelSubscription = async () => {
    const token = localStorage.getItem('accessToken');
    console.log('CSRF Token before request:', csrfToken);
    try {
      const response = await axios.post(`${API_URL}/api/cancel_subscription`,
        { csrf_token: csrfToken },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'X-CSRF-TOKEN': csrfToken
          },
          withCredentials: true
        }
      );
      if (response.status === 200) {
        alert('Subscription cancelled successfully');
        fetchSubscriptionData();
      }
    } catch (error) {
      console.error('Error cancelling subscription:', error);
      alert('Failed to cancel subscription');
    }
    setFinalWarningOpen(false);
  };

  const handleReactivateSubscription = () => {
    setConfirmReactivateOpen(true);
  };

  const confirmReactivateSubscription = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios.post(`${API_URL}/api/reactivate_subscription`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-CSRFToken': csrfToken // Add this line
        },
        withCredentials: true
      });
      if (response.status === 200) {
        alert('Subscription reactivated successfully');
        fetchSubscriptionData();
      }
    } catch (error) {
      console.error('Error reactivating subscription:', error);
      alert('Failed to reactivate subscription');
    }
    setConfirmReactivateOpen(false);
  };

  const handleProfileChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value,
    });
  };

  const handleProfileUpdate = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      await axios.put(`${API_URL}/api/user_details`, profile, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken
        },
        withCredentials: true
      });
      alert('Profile updated successfully');
      setEditMode(false);
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Failed to update profile');
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidPhoneNumber = (phone) => {
    const phoneRegex = /^\+?[1-9]\d{0,2} ?\(?\d{1,4}\)? ?\d{1,4} ?\d{1,4}( ?\d{1,4})?$/;
    return phoneRegex.test(phone);
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setNewMember({ ...newMember, email });
    if (!isValidEmail(email)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('');
    }
  };

  const handleNameChange = (e) => {
    const name = e.target.value;
    setNewMember({ ...newMember, name });
    if (!name) {
      setNameError('Name is required.');
    } else if (name.length > 100) {
      setNameError('Name must be 100 characters or fewer.');
    } else {
      setNameError('');
    }
  };

  const handlePhoneChange = (phone, country) => {
    const countryCode = country.dialCode;
    const formattedPhone = `+${countryCode} ${phone.slice(countryCode.length)}`;
    setNewMember({ ...newMember, phone_number: formattedPhone });
    if (!isValidPhoneNumber(formattedPhone)) {
      setPhoneError('Please enter a valid phone number.');
    } else {
      setPhoneError('');
    }
  };

  const handleAddMemberClick = () => {
    setShowAddMember((prevShowAddMember) => !prevShowAddMember);
  };

  const handleAddTeamMember = async () => {
    if (!newMember.name) {
      setNameError('Name is required.');
      return;
    }

    if (newMember.name.length > 100) {
      setNameError('Name must be 100 characters or fewer.');
      return;
    }

    if (!isValidEmail(newMember.email)) {
      setEmailError('Please enter a valid email address.');
      return;
    }

    if (newMember.email.length > 255) {
      setEmailError('Email must be 255 characters or fewer.');
      return;
    }

    if (!isValidPhoneNumber(newMember.phone_number)) {
      setPhoneError('Please enter a valid phone number.');
      return;
    }

    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios.post(`${API_URL}/api/team_members`, newMember, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken
        },
        withCredentials: true
      });

      if (response.status === 201) {
        setNewMember({ name: '', email: '', role: roles[1], phone_number: '' });
        setShowAddMember(false);
        alert('Team member added successfully');
        window.location.reload();
      }
    } catch (error) {
      console.error('Error adding team member:', error);
      if (error.response && error.response.status === 400 && error.response.data.message === 'Email already registered') {
        setSnackbarMessage('This user is already added to the organization.');
        setSnackbarOpen(true);
      } else {
        alert('Failed to add team member');
      }
    }
  };

  const handleRemoveTeamMember = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      await axios.delete(`${API_URL}/api/team_members`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken
        },
        withCredentials: true,
        data: { id: editMember.id }
      });
      setTeamMembers(teamMembers.filter(member => member.id !== editMember.id));
      setEditMember(null);
      setConfirmDeleteOpen(false);
      alert('Team member removed successfully');
    } catch (error) {
      console.error('Error removing team member:', error);
      alert('Failed to remove team member');
    }
  };

  const handleRoleChange = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      await axios.put(`${API_URL}/api/team_members`, {
        id: editMember.id,
        role: updatedRole
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken
        },
        withCredentials: true
      });
      setTeamMembers(teamMembers.map(member => member.id === editMember.id ? { ...member, role: updatedRole } : member));
      setEditMember(null);
      setConfirmRoleChangeOpen(false);
      alert('Team member role updated successfully');
    } catch (error) {
      console.error('Error updating team member role:', error);
      alert('Failed to update team member role');
    }
  };

  const handleEditClick = (member) => {
    setEditMember(member);
    setUpdatedRole(member.role);
  };

  const handleRoleSelectChange = (role) => {
    if (role === 'Admin') {
      setConfirmAdminRoleOpen(true);
    } else {
      setUpdatedRole(role);
      setNewMember({ ...newMember, role });
    }
  };

  const confirmAdminRole = () => {
    setUpdatedRole('Admin');
    setNewMember({ ...newMember, role: 'Admin' });
    setConfirmAdminRoleOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleRequestSort = (property) => {
    const isAscending = (orderBy === property && order === 'asc');
    setOrder(isAscending ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedActivities = activities.slice().sort((a, b) => {
    if (orderBy === 'timestamp') {
      return order === 'asc' ? new Date(a.timestamp) - new Date(b.timestamp) : new Date(b.timestamp) - new Date(a.timestamp);
    }
    return 0;
  });

  const toggleView = () => {
    setIsCardView(!isCardView);
  };

  const handleShowEmail = (email) => {
    setSelectedMemberEmail(email);
    setEmailModalOpen(true);
  };

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleUpgradePlan = (planId) => {
    setSelectedPlanId(planId);
    setConfirmUpgradeOpen(true);
  };

  const handleConfirmUpgrade = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      await axios.post(
        `${API_URL}/api/upgrade_subscription`,
        { plan_id: selectedPlanId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-CSRFToken': csrfToken,
          },
          withCredentials: true,
        }
      );
      alert('Plan upgraded successfully');
      window.location.reload();
    } catch (error) {
      console.error('Error upgrading plan:', error);
      alert('Failed to upgrade plan');
    }
    setConfirmUpgradeOpen(false);
  };

  const handleDowngradePlan = (planId) => {
    setSelectedPlanId(planId);
    setConfirmDowngradeOpen(true);
  };

  const handleConfirmDowngrade = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      await axios.post(
        `${API_URL}/api/downgrade_subscription`,
        { plan_id: selectedPlanId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-CSRFToken': csrfToken,
          },
          withCredentials: true,
        }
      );
      alert('Plan downgraded successfully');
      window.location.reload();
    } catch (error) {
      console.error('Error downgrading plan:', error);
      alert('Failed to downgrade plan');
    }
    setConfirmDowngradeOpen(false);
  };

  const handleChoosePaymentMethod = (method_name) => {
    setMethodToChange(method_name);
    setConfirmDialogOpen(true);
  };

  const confirmChangePaymentMethod = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios.post(`${API_URL}/api/user/${profile.user_uuid}/payment-method`, { method_name: methodToChange }, {
        headers: { Authorization: `Bearer ${token}`, 'X-CSRFToken': csrfToken },
        withCredentials: true
      });
      if (response.status === 200) {
        setChosenPaymentMethod(methodToChange);
        setConfirmDialogOpen(false);
      }
    } catch (error) {
      console.error('Error choosing payment method:', error);
      setConfirmDialogOpen(false);
    }
  };

  const handleDialogClose = () => {
    setConfirmDialogOpen(false);
    setMethodToChange(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <TopBar darkMode={darkMode} setDarkMode={setDarkMode} handleLogout={handleLogout} />
          <Sidebar handleLogout={handleLogout} />
          <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
            <Toolbar />
            <Typography variant="h6">Loading...</Typography>
          </Box>
        </Box>
      </ThemeProvider>
    );
  }

  if (error) {
    return (
      <ThemeProvider theme={theme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <TopBar darkMode={darkMode} setDarkMode={setDarkMode} handleLogout={handleLogout} />
          <Sidebar handleLogout={handleLogout} />
          <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
            <Toolbar />
            <Alert severity="error">{error}</Alert>
          </Box>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <div className="p-6 pt-16">
      <Box sx={{ display: 'flex' }}>
        <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h4" gutterBottom>
              {profile.company_name}
            </Typography>
            {profile.type !== 'team_member' && (
              <IconButton onClick={toggleEditMode} color="primary" sx={{ ml: 1 }}>
                <EditIcon />
              </IconButton>
            )}
          </Box>
          {editMode ? (
            <>
              <TextField
                label="Organization Name"
                name="organization_name"
                value={profile.organization_name || ''}
                onChange={handleProfileChange}
                fullWidth
                sx={{ mb: 2 }}
              />
              <TextField
                label="Company Address"
                name="company_address"
                value={profile.company_address || ''}
                onChange={handleProfileChange}
                fullWidth
                sx={{ mb: 2 }}
              />
              <Button variant="contained" color="primary" onClick={handleProfileUpdate} sx={{ mb: 2 }}>
                <SaveIcon sx={{ mr: 1 }} /> Save
              </Button>
              <Button variant="contained" color="secondary" onClick={toggleEditMode} sx={{ mb: 2 }}>
                <CancelIcon sx={{ mr: 1 }} /> Cancel
              </Button>
            </>
            ) : (
              <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6 max-w-4xl">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Organization Details</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                  <div className="space-y-1">
                    <p className="text-sm font-medium text-gray-500">Organization Name</p>
                    <p className="text-base text-gray-800">{profile.organization_name}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-sm font-medium text-gray-500">Company Address</p>
                    <p className="text-base text-gray-800">{profile.company_address}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-sm font-medium text-gray-500">Organization Number</p>
                    <p className="text-base text-gray-800">{profile.organization_number}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-sm font-medium text-gray-500">Country</p>
                    <p className="text-base text-gray-800">{profile.country}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-sm font-medium text-gray-500">Contact Person</p>
                    <p className="text-base text-gray-800">{profile.contact_person}</p>
                  </div>
                </div>
              </div>
            )}


          <Tabs value={tabIndex} onChange={handleTabChange} className="tabs-container">
            <Tab label="Team Members" />
            {(profile.role === 'Admin' || profile.type === 'user') && <Tab label="Recent Activity" />}
            {(profile.role === 'Admin' || profile.type === 'user') && <Tab label="Subscription" />}
            {(profile.role === 'Admin' || profile.type === 'user') && <Tab label="Billing & Payment" />}
            {(profile.role === 'Admin' || profile.type === 'user') && <Tab label="Account Actions" />}
          </Tabs>

          {tabIndex === 0 && (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 4, mb: 2 }}>
                <Typography variant="h5">Team Members</Typography>
                <FormControlLabel
                  control={<Switch checked={isCardView} onChange={toggleView} />}
                  label={isCardView ? 'Card View' : 'Table View'}
                />
              </Box>

              {isCardView ? (
                <Grid container spacing={3}>
                  {teamMembers.map((member) => (
                    <Grid item xs={12} sm={6} md={4} key={member.id}>
                      <Paper className="team-member-card">
                        <Avatar alt={member.name} src="/path-to-avatar.jpg" className="avatar" />
                        <Typography variant="h6" className="member-name">{member.name}</Typography>
                        <Typography variant="body2" className="member-role">{member.role}</Typography>
                        {!(profile.role === 'Member' || profile.role === 'Viewer') && (
                          <>
                            <Typography variant="body2" className="member-info">Last Login: {member.last_login ? new Date(member.last_login).toLocaleString() : 'N/A'}</Typography>
                            <Typography variant="body2" className="member-info">Last Login IP: {member.last_login_ip ? member.last_login_ip : 'N/A'}</Typography>
                          </>
                        )}
                        {!(profile.role === 'Member' || profile.role === 'Viewer') && (
                          <IconButton onClick={() => handleEditClick(member)} color="primary">
                            <EditIcon />
                          </IconButton>
                        )}
                        <IconButton onClick={() => handleShowEmail(member.email)} color="primary">
                          <EmailIcon />
                        </IconButton>
                      </Paper>
                    </Grid>
                  ))}
                  {!(profile.role === 'Member' || profile.role === 'Viewer') && (
                    <Grid item xs={12} sm={6} md={4}>
                      <Paper className="team-member-card">
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 2 }}>
                          <Typography variant="h6">Add Team Member</Typography>
                          <IconButton onClick={toggleAddMemberForm} color="primary">
                            {showAddMember ? <RemoveIcon /> : <AddIcon />}
                          </IconButton>
                        </Box>
                        {showAddMember && (
                          <Box component="form" className="add-team-member-form" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2, padding: 2 }}>
                            <TextField
                              label="Name"
                              name="name"
                              value={newMember.name}
                              onChange={handleNameChange}
                              fullWidth
                              inputProps={{ maxLength: 100 }}
                            />
                            {nameError && <Alert severity="error">{nameError}</Alert>}
                            <TextField
                              label="Email"
                              name="email"
                              value={newMember.email}
                              onChange={handleEmailChange}
                              fullWidth
                              inputProps={{ maxLength: 255 }}
                              type="email"
                            />
                            {emailError && <Alert severity="error">{emailError}</Alert>}
                            <Box onClick={(e) => e.stopPropagation()} sx={{ width: '100%' }}>
                              <PhoneInput
                                country={'us'}
                                value={newMember.phone_number}
                                onChange={handlePhoneChange}
                                inputProps={{
                                  name: 'phone',
                                  required: true,
                                  autoFocus: false
                                }}
                                containerStyle={{ width: '100%' }}
                                inputStyle={{ width: '100%' }}
                                buttonStyle={{ borderRadius: '4px 0 0 4px' }}
                                dropdownStyle={{ width: 'auto' }}
                              />
                            </Box>
                            {phoneError && <Alert severity="error">{phoneError}</Alert>}
                            <Select
                              label="Role"
                              name="role"
                              value={newMember.role}
                              onChange={(e) => handleRoleSelectChange(e.target.value)}
                              fullWidth
                            >
                              {roles.map((role, index) => (
                                <MenuItem key={index} value={role}>{role}</MenuItem>
                              ))}
                            </Select>
                            <Button variant="contained" color="primary" onClick={handleAddTeamMember} className="button">
                              Add Team Member
                            </Button>
                          </Box>
                        )}
                      </Paper>
                    </Grid>
                  )}
                </Grid>
              ) : (
                <TableContainer component={Paper} className="table-container">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Role</TableCell>
                        <TableCell>Phone Number</TableCell>
                        {!(profile.role === 'Member' || profile.role === 'Viewer') && (
                          <>
                            <TableCell>Last Login</TableCell>
                            <TableCell>Last Login IP</TableCell>
                          </>
                        )}
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {teamMembers.map((member) => (
                        <TableRow key={member.id}>
                          <TableCell>{member.name}</TableCell>
                          <TableCell>{member.email}</TableCell>
                          <TableCell>{member.role}</TableCell>
                          <TableCell>{member.phone_number}</TableCell>
                          {!(profile.role === 'Member' || profile.role === 'Viewer') && (
                            <>
                              <TableCell>{member.last_login ? new Date(member.last_login).toLocaleString() : 'N/A'}</TableCell>
                              <TableCell>{member.last_login_ip ? member.last_login_ip : 'N/A'}</TableCell>
                            </>
                          )}
                          <TableCell>
                            {!(profile.role === 'Member' || profile.role === 'Viewer') && (
                              <IconButton onClick={() => handleEditClick(member)} color="primary">
                                <EditIcon />
                              </IconButton>
                            )}
                            <IconButton onClick={() => handleShowEmail(member.email)} color="primary">
                              <EmailIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </>
          )}

          {tabIndex === 1 && (profile.role === 'Admin' || profile.type === 'user') && (
            <Box>
              <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
                Recent Activity
              </Typography>
              <TableContainer component={Paper} className="table-container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <TableSortLabel
                          active={orderBy === 'timestamp'}
                          direction={order}
                          onClick={() => handleRequestSort('timestamp')}
                        >
                          Timestamp
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Description</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedActivities
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((activity) => (
                        <TableRow key={activity.id}>
                          <TableCell>{moment(activity.timestamp).format('DD MMM, YYYY HH:mm')}</TableCell>
                          <TableCell>{activity.type}</TableCell>
                          <TableCell>{activity.description}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={activities.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Box>
          )}

          {tabIndex === 2 && (profile.role === 'Admin' || profile.type === 'user') && (
            <Box>
              <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
                Subscription
              </Typography>
              {subscription.plan_name ? (
                <Paper sx={{ p: 2 }}>
                  <Typography variant="body1">Plan: {subscription.plan_name}</Typography>
                  <Typography variant="body1">Status: {subscription.status}</Typography>
                  <Typography variant="body1">Storage: {subscription.storage}</Typography>
                  <Typography variant="body1">Price: ${subscription.price}/year</Typography>
                  <Typography variant="body1">Next Billing Date: {moment(subscription.next_billing_date).format('DD MMM, YYYY')}</Typography>
                  <Box sx={{ mt: 2 }}>
                    {subscription.status === 'active' ? (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleCancelSubscription}
                      >
                        Cancel Subscription
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleReactivateSubscription}
                      >
                        Reactivate Subscription
                      </Button>
                    )}
                  </Box>
                </Paper>
              ) : (
                <Alert severity="info">Subscription will appear as soon as any AI model, dataset, or project files are added to your account.</Alert>
              )}
              <Typography variant="h6" sx={{ mt: 4 }}>
                Available Plans
              </Typography>
              <Grid container spacing={2}>
                {availablePlans.map((plan) => (
                  <Grid item xs={12} sm={6} md={4} key={plan.id}>
                    <Paper
                      sx={{
                        p: 2,
                        textAlign: 'center',
                        height: '100%',
                        backgroundColor: plan.plan_name === subscription.plan_name ? 'lightblue' : 'white'
                      }}
                    >
                      <Typography variant="h6">{plan.plan_name}</Typography>
                      <Typography variant="body1">Storage: {plan.storage_limit}</Typography>
                      <Typography variant="body1">Price: ${plan.price_per_year}/year</Typography>
                      {plan.plan_name === subscription.plan_name || subscription.status === 'cancelled' ? (
                        <Button variant="contained" color="primary" sx={{ mt: 2 }} disabled>
                          {plan.plan_name === subscription.plan_name ? 'Selected' : 'Select'}
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ mt: 2 }}
                          onClick={() => plan.price_per_year > subscription.price ? handleUpgradePlan(plan.id) : handleDowngradePlan(plan.id)}
                          disabled={profile.role === 'Member' || profile.role === 'Viewer'}
                        >
                          {plan.price_per_year > subscription.price ? 'Upgrade Plan' : 'Downgrade Plan'}
                        </Button>
                      )}
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {tabIndex === 3 && (profile.role === 'Admin' || profile.type === 'user') && (
            <Box>
              <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
                Billing & Payment
              </Typography>

              {subscription.plan_name ? (
                <>
                  <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
                    Choose Payment Method
                  </Typography>
                  <Grid container spacing={2}>
                    {paymentMethods.map((method) => (
                      <Grid item xs={12} sm={4} key={method.method_name}>
                        <Paper
                          sx={{
                            p: 2,
                            textAlign: 'center',
                            height: '100%',
                            backgroundColor: method.method_name === chosenPaymentMethod ? 'lightblue' : 'white'
                          }}
                        >
                          <Typography variant="h6">{method.method_name}</Typography>
                          <Typography variant="body2" sx={{ mt: 2, mb: 2 }}>
                            {method.description}
                          </Typography>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2 }}
                            onClick={() => handleChoosePaymentMethod(method.method_name)}
                            disabled={method.method_name === chosenPaymentMethod}
                          >
                            {method.method_name === chosenPaymentMethod ? 'Selected' : 'Select'}
                          </Button>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </>
              ) : (
                <Alert severity="info">Payment method options will appear as soon as any AI model, dataset, or project files are added to your account.</Alert>
              )}
              <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
                Billing History
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Invoice Number</TableCell>
                      <TableCell>Amount</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Created At</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {billingHistory.map((entry) => (
                      <TableRow key={entry.invoice_number}>
                        <TableCell>{entry.invoice_number}</TableCell>
                        <TableCell>{entry.amount}</TableCell>
                        <TableCell>{entry.description}</TableCell>
                        <TableCell>{entry.status}</TableCell>
                        <TableCell>{moment(entry.created_at).format('DD MMM, YYYY')}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {tabIndex === 4 && (profile.role === 'Admin' || profile.type === 'user') && (
            <Box>
              <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
                Account Actions
              </Typography>
              <Paper sx={{ p: 2 }}>
              <Button
                variant="contained"
                color={deletionStatus === 'pending' ? 'secondary' : 'error'}
                onClick={handleToggleAccountDeletion}
              >
                {deletionStatus === 'pending' ? 'Cancel Account Deletion Request' : 'Request Account Deletion'}
              </Button>
              </Paper>
            </Box>
          )}
        </Box>
      </Box>

      <Dialog
        open={confirmDeleteAccountOpen}
        onClose={() => setConfirmDeleteAccountOpen(false)}
      >
        <DialogTitle>
          {deletionStatus === 'pending' ? 'Cancel Account Deletion Request' : 'Confirm Account Deletion Request'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {deletionStatus === 'pending' 
              ? 'Are you sure you want to cancel your account deletion request?'
              : 'Are you sure you want to request account deletion? This action will initiate the process to delete your account and all associated data. This process may take some time and is irreversible once completed.'
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDeleteAccountOpen(false)}>Cancel</Button>
          <Button onClick={confirmToggleAccountDeletion} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {editMember && (
        <Dialog
          open={!!editMember}
          onClose={() => setEditMember(null)}
          aria-labelledby="edit-member-dialog-title"
          aria-describedby="edit-member-dialog-description"
        >
          <DialogTitle id="edit-member-dialog-title">Edit Team Member</DialogTitle>
          <DialogContent>
            <DialogContentText id="edit-member-dialog-description">
              You can change the role or remove the team member.
            </DialogContentText>
            <Select
              label="Role"
              name="role"
              value={updatedRole}
              onChange={(e) => handleRoleSelectChange(e.target.value)}
              fullWidth
            >
              {roles.map((role, index) => (
                <MenuItem key={index} value={role}>{role}</MenuItem>
              ))}
            </Select>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmDeleteOpen(true)} color="error">Remove</Button>
            <Button onClick={() => setConfirmRoleChangeOpen(true)} color="primary">Change Role</Button>
            <Button onClick={() => setEditMember(null)}>Cancel</Button>
          </DialogActions>
        </Dialog>
      )}
      <Dialog
        open={confirmCancelOpen}
        onClose={handleCancelSubscriptionClose}
      >
        <DialogTitle>Cancel Subscription</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to cancel your subscription? You will lose access to premium features at the end of your current billing period.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelSubscriptionClose}>No, Keep My Subscription</Button>
          <Button onClick={handleFinalWarning} color="secondary">Yes, Proceed to Final Warning</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={finalWarningOpen}
        onClose={handleCancelSubscriptionClose}
      >
        <DialogTitle>Final Warning</DialogTitle>
        <DialogContent>
          <DialogContentText>
            WARNING: If you cancel your subscription, all AI model weights will be permanently deleted at the end of your current billing period. These cannot be shared or transferred due to proprietary technology.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelSubscriptionClose}>No, Keep My Subscription</Button>
          <Button onClick={confirmCancelSubscription} color="secondary">Yes, I Understand. Cancel Subscription</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmReactivateOpen}
        onClose={() => setConfirmReactivateOpen(false)}
      >
        <DialogTitle>Reactivate Subscription</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to reactivate your subscription? You will be billed for the next billing period and regain access to all premium features.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmReactivateOpen(false)}>No, Keep It Cancelled</Button>
          <Button onClick={confirmReactivateSubscription} color="primary">Yes, Reactivate Subscription</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
        aria-labelledby="confirm-delete-dialog-title"
        aria-describedby="confirm-delete-dialog-description"
      >
        <DialogTitle id="confirm-delete-dialog-title">Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-delete-dialog-description">
            Are you sure you want to remove {editMember?.name} from the team?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDeleteOpen(false)}>Cancel</Button>
          <Button onClick={handleRemoveTeamMember} color="error">Delete</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmRoleChangeOpen}
        onClose={() => setConfirmRoleChangeOpen(false)}
        aria-labelledby="confirm-role-change-dialog-title"
        aria-describedby="confirm-role-change-dialog-description"
      >
        <DialogTitle id="confirm-role-change-dialog-title">Confirm Role Change</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-role-change-dialog-description">
            Are you sure you want to change {editMember?.name}'s role to {updatedRole}?
            {updatedRole === 'Admin' && ' This action grants administrative privileges.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmRoleChangeOpen(false)}>Cancel</Button>
          <Button onClick={handleRoleChange} color="primary">Change Role</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmAdminRoleOpen}
        onClose={() => setConfirmAdminRoleOpen(false)}
        aria-labelledby="confirm-admin-role-dialog-title"
        aria-describedby="confirm-admin-role-dialog-description"
      >
        <DialogTitle id="confirm-admin-role-dialog-title">Confirm Admin Role</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-admin-role-dialog-description">
            Are you sure you want to assign the Admin role to this member? This action grants administrative privileges.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmAdminRoleOpen(false)}>Cancel</Button>
          <Button onClick={confirmAdminRole} color="primary">Confirm</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={emailModalOpen}
        onClose={() => setEmailModalOpen(false)}
        aria-labelledby="email-modal-title"
        aria-describedby="email-modal-description"
      >
        <DialogTitle id="email-modal-title">Team Member Email</DialogTitle>
        <DialogContent>
          <DialogContentText id="email-modal-description">
            {selectedMemberEmail}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEmailModalOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmDialogOpen}
        onClose={handleDialogClose}
      >
        <DialogTitle>Change Payment Method</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to change your payment method to {methodToChange}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmChangePaymentMethod} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmUpgradeOpen}
        onClose={() => setConfirmUpgradeOpen(false)}
      >
        <DialogTitle>Upgrade Plan</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to upgrade your subscription to this plan?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmUpgradeOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirmUpgrade} color="primary">Confirm</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmDowngradeOpen}
        onClose={() => setConfirmDowngradeOpen(false)}
      >
        <DialogTitle>Downgrade Plan</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to downgrade your subscription to this plan?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDowngradeOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirmDowngrade} color="primary">Confirm</Button>
        </DialogActions>
      </Dialog>
    </div>
  );

};

export default OrganizationDashboard;
